export const filterFreeSoloOperators = new Set([
  "contains",
  "does_not_contain",
  "starts_with",
  "ends_with",
]);
